import { Token } from './token';

export class OAuthResponse {
	accessToken: string;
	tokenType: string;
	state: string;
	scope: string;
	expiresIn: number;
	expiresAt: Date;
	refreshToken: string;
	constructor() {
		this.accessToken = '';
		this.tokenType = '';
		this.state = '';
		this.scope = '';
		this.expiresIn = 0;
		this.refreshToken = '';
	}

	getToken(): Token {
		let t = new Token();
		t.accessToken = this.accessToken;
		t.tokenType = this.tokenType;
		t.state = this.state;
		t.scope = this.scope;
		t.expiresIn = this.expiresIn;
		t.expiresAt = this.expiresAt;
		t.refreshToken = this.refreshToken;
		return t;
	}
}
